import { createSlice } from '@reduxjs/toolkit'

export const loginSlice = createSlice({
  name: 'globals',
  initialState: {
      apiRoot: process.env.REACT_APP_LEGACY_API_ENDPOINT || "ApiRootNotConfiguredCorrectly"
  }
})

export default loginSlice.reducer